var _rect, _rect2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileHashSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 1108,
    transform: "translate(-570 -125)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F0FDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 45C43 42.2656 45.1875 40 48 40H60.5V50C60.5 51.4062 61.5938 52.5 63 52.5H73V55.5469C67.2188 57.1875 63 62.5 63 68.75C63 73.4375 65.2656 77.5 68.7031 80C68.4688 80 68.2344 80 68 80H48C45.1875 80 43 77.8125 43 75V45ZM63 50V40L73 50H63ZM88 68.75C88 75 82.9219 80 76.75 80C70.5 80 65.5 75 65.5 68.75C65.5 62.5781 70.5 57.5 76.75 57.5C82.9219 57.5 88 62.5781 88 68.75ZM80.1875 65.3906L75.5 70.1562L73.2344 67.8906C72.7656 67.4219 71.9062 67.4219 71.4375 67.8906C70.9688 68.3594 70.9688 69.2188 71.4375 69.6875L74.5625 72.8125C75.0312 73.2812 75.8906 73.2812 76.3594 72.8125L81.9844 67.1875C82.4531 66.7188 82.4531 65.8594 81.9844 65.3906C81.5156 64.9219 80.6562 64.9219 80.1875 65.3906Z",
    fill: "#3CC0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHashSuccess);
export default __webpack_public_path__ + "static/media/file-hash-success.fa940fc8c29ad9af16383eaf0a10d463.svg";
export { ForwardRef as ReactComponent };